import { usePartnerControllerGetCategoriesQuery } from '@api/admin/adminGeneratedApi';

export const useGetCategories = (search: string = '') => {
  const { data, isLoading } = usePartnerControllerGetCategoriesQuery({
    search,
  });

  return {
    data,
    isLoading,
  };
};
